import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export const FAQS = [
  ["الكورسات مسجلة ولا لايف؟", "كل الكورسات مسجلة بالكامل، تقدر تتفرج عليها في أي وقت يناسبك وتعيد الدروس براحتك."],
  ["إزاي أدفع تمن الكورس؟", "بتحوّل قيمة الكورس عن طريق فودافون كاش أو إنستاباي على الرقم الموضح في صفحة الدفع، وبعدها ترفع صورة إيصال التحويل من حسابك."],
  ["الكورس بيتفعل امتى بعد الدفع؟", "فريق الأكاديمية بيراجع إيصال الدفع ويفعّل الكورس لحسابك بعد التأكد من التحويل، وتقدر تتابع حالة الطلب من لوحة الطالب."],
  ["أقدر أتفرج من الموبايل؟", "أيوه، المنصة شغالة على الموبايل والتابلت والكمبيوتر من المتصفح مباشرة."],
  ["هل أقدر أشارك حسابي مع حد تاني؟", "لا، الحساب شخصي ومرتبط بيك. الفيديوهات عليها علامة مائية باسمك، ومشاركة الحساب أو المحتوى ممكن تؤدي لإيقاف الحساب."],
  ["محتاج خبرة قبل ما أبدأ؟", "كل كورس موضح فيه المستوى والمتطلبات. في كورسات للمبتدئين تماماً بتبدأ معاك من الصفر."],
  ["لو عندي مشكلة أتواصل مع مين؟", "تقدر تكلمنا على واتساب الدعم أو صفحتنا على فيسبوك، والروابط موجودة في صفحة التواصل."],
];

export const FaqList = ({ items = FAQS }) => (
  <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
    {items.map(([q, a], i) => (
      <AccordionItem key={q} value={`f${i}`} className="rounded-2xl border-2 border-line bg-white px-5 data-[state=open]:border-white transition-colors">
        <AccordionTrigger data-testid={`faq-item-${i}`} className="text-right font-heading text-base sm:text-lg font-semibold text-ink hover:no-underline">{q}</AccordionTrigger>
        <AccordionContent className="text-soft leading-relaxed text-sm sm:text-base">{a}</AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
